// Разделяем missingVars на 2 группы: scalar (`vendor`, `title`, …) — реальная
// нехватка данных, отображаем красным. Dynamic (`params.*`, `properties.*`) —
// норма, у каждого товара свой набор, не пугаем юзера.
export const splitMissingVars = (missingVars: string[]) => {
  const scalar: string[] = [];
  const dynamic: string[] = [];
  for (const v of missingVars) {
    (v.includes(".") ? dynamic : scalar).push(v);
  }
  return { scalar, dynamic };
};
